<template>
  <div class="accordion"
    :class="{'is-open': this.isToggled}"
  >
    <div class="accordion-header"
      :style="style"
      @click="this.toggleHandler"
    >
      {{ text }} {{ info }}
      <i class="fas fa-chevron-up" :style="iconColor"
      ></i>
    </div>
    <div
      class="accordion-body"
      :id="criteria"
      :ref="`accordion-body-${this.criteria}`"
      :style="bodyAnimation"
    >

        <div class="accordion-item-wrapper"
            v-for="(option, index) in options"
            :key="option"
        >

        <div class="accordion-item">

            <div class="accordion-checkbox">
              <input
                class="accordion-checkbox-input"
                type="checkbox"
                @change="$emit('accordion-item-toggled', $event, {criteria, 'selected': option})"
                :value="option"
                v-model="cache"
                :disabled="isNotApplicable(option)"
              />
            </div>

            <div class="accordion-label" :class="{'not-applicable':isNotApplicable(option)}">{{ option }}</div>
        </div>

        <div class="accordion-indent">
          <div class="accordion-item" v-if="isNegatable(index)">
            <div class="accordion-checkbox">
              <input
                  class="accordion-checkbox-input"
                  id="not-applicable"
                  type="checkbox"
                  :value="option"
                  v-model="notApplicable"
                  @change="(event) => removeOption(event, option)"
                />
              </div>
              <div class="accordion-label">{{ getNotApplicableText(option) }}</div>
          </div>
        </div>

        <div class="accordion-indent" v-if="hasMaster && hasSelectedFirst">
            <div class="accordion-item-wrapper"
              v-for="extra in extraCriteria"
              :key="extra"
            >
              <div class="accordion-item">
                <div class="accordion-checkbox">
                  <input class="accordion-checkbox-input"
                    type="checkbox"
                    :value="extra"
                    v-model="cache"
                    @change="$emit('accordion-item-toggled', $event, {criteria, 'selected': extra})"
                  />
                </div>
                <div class="accordion-label">{{ extra }}</div>
              </div>
            </div>
          </div>

        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: ['criteria', 'criterion', 'open', 'hasMaster', 'savedData', 'info', 'negatable'],
  data() {
    return {
      names: {
        not_applicable: {
          text: 'Not Applicable',
          color: '#D4D6E4'
        },
        outstanding: {
          text: 'Outstanding',
          color: '#00B9C1'
        },
        good: {
          text: 'Good',
          color: '#49E5A6'
        },
        requires_improvement: {
          text: 'Requires Improvement',
          color: '#FFCB4B'
        },
        inadequate: {
          text: 'Inadequate',
          color: '#E76D93'
        },
        essential: {
          text: 'Clearly Includes',
          color: '#00B9C1'
        }
      },
      cache: [],
      notApplicable: [],
      isToggled: false
    }
  },
  computed: {
    options() {
      if (this.hasMaster) {
        const options = [...this.criterion]
        return [options.shift()]
      }
      return this.criterion
    },
    extraCriteria() {
      if (this.hasMaster) {
        return this.criterion.slice(1)
      }
      return null
    },
    hasSelectedFirst() {
      return this.cache.includes(this.options[0])
    },
    color() {
      return this.names[this.criteria].color
    },
    text() {
      return this.names[this.criteria].text
    },
    iconColor() {
      return {
        color: this.isToggled
          ? this.color
          : 'inherit'
      }
    },
    style() {
      return {
        background: this.isToggled
          ? `linear-gradient(90deg, ${this.color}, transparent)`
          : 'linear-gradient(90deg, transparent, transparent)',
        fontWeight: 600
      }
    },
    bodyRef() {
      return `accordion-body-${this.criteria}`
    },
    bodyAnimation() {
      return {
        'max-height': this.isToggled
          ? '100%'
          : '0px'
      }
    }
  },
  methods: {
    isNotApplicable(option) {
      return this.notApplicable.length > 0 ? this.notApplicable.some((n) => n === option) : false
    },
    getNotApplicableText(criteria) {
      const noAccessMsg = '(e.g. Individual who is auditing does not have access to this data / info [e.g. DCO])'
      const criteriaArray = [
        "Child / young person's details are provided and are correct (e.g.name, DOB, pronoun etc)",
        'Advice provided within 6 weeks of the date of request from the local authority'
      ]

      const isNoAccessMsg = criteriaArray.some((c) => c === criteria)

      return 'Not applicable' + (isNoAccessMsg ? ' ' + noAccessMsg : '')
    },
    isNegatable(index) {
      return this.negatable.length > 0 ? this.negatable.some((n) => n === index) : false
    },
    removeOption(event, option) {
      if (this.cache.includes(option)) {
        this.cache.splice(this.cache.indexOf(option), 1)
      }

      this.$emit('accordion-item-toggled', event, { criteria: this.criteria, selected: option })
    },
    toggleHandler() {
      this.isToggled = !this.isToggled

      return this.isToggled
    }
  },
  watch: {
    '$route.params.id': {
      handler() {
        this.cache = []
        if (this.savedData && this.savedData.criteria[this.criteria]) {
          this.notApplicable = this.savedData.criteria[this.criteria]
            .filter((c) => c.match(/^Not applicable - /))
            .map((c) => c.replace(/^Not applicable - /, ''))
          this.cache = this.savedData.criteria[this.criteria].slice()
          this.$nextTick(() => console.log('3', this.cache))
        }
      }
    }
  },

  mounted() {
    if (this.savedData && this.savedData.criteria[this.criteria]) {
      this.notApplicable = this.savedData.criteria[this.criteria]
        .filter((c) => c.match(/^Not applicable - /))
        .map((c) => c.replace(/^Not applicable - /, ''))
      this.cache = this.savedData.criteria[this.criteria].slice()
      this.$nextTick(() => console.log('3', this.cache))
    }

    this.isToggled = (this.criteria === 'good')
  }
}
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";
@import "@/style/accordion.scss";

.extra-criteria {
  padding-top: 1rem;
  margin-left: 1rem;
}

.extra-item {
  padding: 8px;
  display: flex;
  gap: 4px;
  align-items: flex-start;

  input {
    margin: 6px 0 0 6px;
  }

  label {
    margin: 0;
  }
}
</style>
